import React from 'react';
import { BooleanInput, SearchInput } from 'react-admin';
import GetAppIcon from '@mui/icons-material/GetApp';

import List, { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';
import CompanyRow from './CompanyRow';

import { API_URL } from '../../services/settings';

const CompanyListActions = (props) => (
    <ListActions {...props}>
        <IconButton icon={<GetAppIcon />} component="a" href={`${API_URL}/companies/export.xls`}>Export</IconButton>
    </ListActions>
);


const companyFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput label="Archived" source="archived" alwaysOn />
];

const filterDefaultValues = {
    archived: false
};

const CompanyList = props => (
    <List {...props} filters={companyFilters} filterDefaultValues={filterDefaultValues} actions={<CompanyListActions />} exporter={false} >
        <CompanyRow />
    </List>
);

export default CompanyList;